import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import DataguardBehaviorModel from '../DataguardBehaviorModel';
import TopPolicyRadial from '../TopPolicyRadial';
import { formatNumber } from '../../Utility/DataguardConstant';
import FullscreenIcon from "@material-ui/icons/Fullscreen";

const BehaviorModelsCard = ({ showExpandedView, isPopup = false, onClick, style }) => {
  const [totalPolicies, setTotalPolicies] = useState(0);
  const [totalAlertPolicies, setTotalAlertPolicies] = useState(0);
  const behaviorData = useSelector((state) => state.DataguardReducer.behaviorData);

  useEffect(() => {
    if (behaviorData) {
      setTotalPolicies(behaviorData.totalNoOfPolicies);
      setTotalAlertPolicies(behaviorData.totalNoOfAlerts);
    }
  }, [behaviorData]);

  return (
    <div className="column-card behavior-models-card" style={style}>
      <div className='details-container behavior-model-container' onClick={onClick}>
        <div className='left-details'>
          <div className='left-details-container'>
            <div className='icon-container'>
              <img src='/dataguardIcons/behavior.svg' alt='Behavior Icon' />
              <span className='ico-label'>Behavior Models</span>
            </div>
            <div className='left-details-txt'>
              <span>Total # of Policies</span>
              <span className='no-locs' title={totalPolicies}>{formatNumber(totalPolicies)}</span>
            </div>
            <div className='left-details-txt'>
              <span>Total # of Alerts</span>
              <span className='loc-alert' title={totalAlertPolicies}>{formatNumber(totalAlertPolicies)}</span>
            </div>
            {isPopup && <div className='top-policy-legend'>
              <div className='ico-label'>
                <span title='Alerts from Top 3 Policies'>Top 3 Policies</span>
              </div>
              <div className='lst-container'>
                {behaviorData && behaviorData.top3PolicyViolations && <TopPolicyRadial data={behaviorData} />}
              </div>
            </div>}
          </div>
        </div>
        <div className='right-chart'>
          <DataguardBehaviorModel loc={isPopup ? 'dashboardPopup' : 'default'} />
        </div>
      </div>
        {!isPopup && <div className='top-policy-legend'>
              <div className='ico-label'>
                <span title='Alerts from Top 3 Policies'>Top 3 Policies</span>
              </div>
              <div className='lst-container'>
                {behaviorData && behaviorData.top3PolicyViolations && <TopPolicyRadial data={behaviorData} />}
              </div>
            </div>}
      {!isPopup ? (
        <div className='fullscreen-icon policy' onClick={(e) => { showExpandedView('policy'); e.stopPropagation(); }}>
          <FullscreenIcon fontSize="small" />
        </div>
      ) : (
        null
      )}
    </div>
  );
};

export default BehaviorModelsCard;